import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalCenter, ModalCenterRef } from '@shared/components/ui/ModalCenter';
import { Button } from '@shared/components/ui/button';
import { EnterIcon, EscIcon } from '@shared/components/ui/icons';

export interface UpdateFromStoreModalRef {
  open: () => void;
  close: () => void;
}

type UpdateFromStoreModalProps = Record<never, never>;

export const UpdateFromStoreModal = forwardRef<UpdateFromStoreModalRef, UpdateFromStoreModalProps>((_, ref) => {
  const { t } = useTranslation('ordersShippedModule');
  const modalRef = useRef<ModalCenterRef>(null);

  useImperativeHandle(ref, () => ({
    open: () => {
      modalRef.current?.openModal();
    },
    close: () => {
      modalRef.current?.closeModal();
    },
  }));

  const handleConfirm = () => {
    // Por ahora solo cerrar la ventana, sin llamada API
    modalRef.current?.closeModal();
  };

  const handleCancel = () => {
    modalRef.current?.closeModal();
  };

  return (
    <ModalCenter ref={modalRef} title={t('confirmModals.updateFromStoreModal.title')} type="default">
      <div className="space-y-4">
        <div className="space-y-3">
          <p className="text-sm">{t('confirmModals.updateFromStoreModal.message1')}</p>
          <p className="text-sm">{t('confirmModals.updateFromStoreModal.message2')}</p>
        </div>

        <div className="flex justify-end gap-2 pt-4">
          <Button variant="outline" size="lg" onClick={handleCancel}>
            {t('buttons.cancel')}
            <EscIcon className="w-4 h-4" />
          </Button>
          <Button variant="primary" size="lg" onClick={handleConfirm}>
            {t('buttons.confirm')}
            <EnterIcon className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </ModalCenter>
  );
});

UpdateFromStoreModal.displayName = 'UpdateFromStoreModal';
